import { useState } from "react";
import { OCCASIONS } from "../lib/brand";
import { useReveal } from "../hooks/useReveal";

export const Occasions = () => {
  const headRef = useReveal();
  const [active, setActive] = useState(0);
  const current = OCCASIONS[active];

  return (
    <section
      id="occasions"
      data-testid="occasions-section"
      className="py-24 md:py-40 border-b border-black/100"
    >
      <div className="max-w-[1480px] mx-auto px-6 md:px-12">
        <div ref={headRef} className="reveal flex items-end justify-between mb-12 md:mb-20 gap-8">
          <div>
            <div className="label-eyebrow mb-4">Occasions · Vol. II</div>
            <h2 className="font-display text-[2.6rem] md:text-7xl leading-[0.95] tracking-[-0.015em]">
              Every occasion, <br />
              <span className="italic">kept in frame.</span>
            </h2>
          </div>
          <p className="hidden md:block font-body text-[15px] leading-[1.8] text-black/70 max-w-sm">
            From caps &amp; gowns to mehndi nights, our kits travel with the
            people who care about how their world is kept. Hover the list —
            see the moment.
          </p>
        </div>

        <div className="grid grid-cols-12 gap-8 md:gap-12 items-start">
          {/* Left: interactive list */}
          <div className="col-span-12 md:col-span-6 order-2 md:order-1">
            <ul className="divide-y divide-black/100 border-t border-b border-black/100">
              {OCCASIONS.map((o, i) => (
                <li
                  key={o.title}
                  data-testid={`occasion-item-${i}`}
                  onMouseEnter={() => setActive(i)}
                  onFocus={() => setActive(i)}
                  tabIndex={0}
                  className={`group py-6 md:py-8 px-1 cursor-pointer transition-all duration-500 outline-none
                    ${active === i ? "pl-4 md:pl-6 bg-black text-white" : "hover:pl-4 md:hover:pl-6"}`}
                >
                  <div className="flex items-baseline justify-between gap-6">
                    <div className="flex items-baseline gap-4 md:gap-8">
                      <span className={`label-eyebrow ${active === i ? "opacity-70" : "opacity-50"}`}>
                        {o.tag}
                      </span>
                      <h3 className="font-display text-3xl md:text-5xl leading-none tracking-[-0.01em]">
                        {o.title}
                      </h3>
                    </div>
                    <span
                      aria-hidden
                      className={`font-display text-xl md:text-2xl transition-transform duration-500 ${
                        active === i ? "translate-x-1" : "opacity-40 group-hover:opacity-80"
                      }`}
                    >
                      →
                    </span>
                  </div>
                  <p
                    className={`font-body text-sm md:text-[15px] leading-[1.75] mt-3 md:mt-4 max-w-2xl transition-opacity duration-500 ${
                      active === i ? "opacity-90" : "opacity-70"
                    }`}
                  >
                    {o.blurb}
                  </p>
                </li>
              ))}
            </ul>

            <div className="mt-10">
              <a
                href="#contact"
                data-testid="occasions-cta"
                className="btn-pill btn-pill-solid"
              >
                Book for your occasion
              </a>
            </div>
          </div>

          {/* Right: sticky preview image */}
          <div className="col-span-12 md:col-span-5 md:col-start-8 order-1 md:order-2">
            <div className="md:sticky md:top-28">
              <div
                data-testid="occasions-active-image"
                key={active}
                className="relative overflow-hidden aspect-[4/5] bg-black/5"
              >
                <img
                  src={current.image}
                  alt={`Occasion — ${current.title}`}
                  loading="lazy"
                  className="editorial-img absolute inset-0 w-full h-full object-cover"
                  style={{
                    animation: "hero-rise 0.8s cubic-bezier(0.22,1,0.36,1) both",
                  }}
                />
                <div className="absolute bottom-4 left-4 md:bottom-6 md:left-6 label-eyebrow text-white mix-blend-difference">
                  {current.tag} · {current.title}
                </div>
              </div>
              <div className="pt-4 flex items-center justify-between">
                <span className="label-micro">{current.title}</span>
                <span className="label-micro italic opacity-60">Kept by Prismatics</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
